import { apiSlice } from "../../../../services";
import { IApiGameSettings } from "../types/game-interfaces";

// ============ Types ============
interface GetGameSettingReq {
    character_id: string;
}

// 後端實際返回的數據結構
interface GameSettingApiData {
    character_id: string;
    game_setting: IApiGameSettings | null;
    updated_at: string;
}

interface GetGameSettingRes {
    status: number;
    message_key: string;
    message: string;
    data: GameSettingApiData;
}

interface UpdateGameSettingReq {
    character_id: string;
    payload: IApiGameSettings;
}

interface UpdateGameSettingRes {
    status: number;
    message_key: string;
    message: string;
    data: null;
}

// ============ API Slice ============
export const gameApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // GET game settings
        getGameSetting: builder.query<GetGameSettingRes, GetGameSettingReq>({
            query: ({ character_id }) => ({
                url: "/character/get_game_setting",
                method: "POST",
                body: { character_id },
            }),
            transformResponse: (response: GetGameSettingRes) => response,
            providesTags: ["Game"],
        }),

        // UPDATE game settings
        updateGameSetting: builder.mutation<UpdateGameSettingRes, UpdateGameSettingReq>({
            query: ({ character_id, payload }) => ({
                url: "/character/update_game_setting",
                method: "POST",
                body: { character_id, ...payload },
            }),
            invalidatesTags: ["Game"],
        }),
    }),
});

export const { useGetGameSettingQuery, useUpdateGameSettingMutation } = gameApiSlice;
